// Only for runtime type checking, will not be stored into any format
export var Pointers;
(function (Pointers) {
    Pointers[Pointers["Deprecated"] = NaN] = "Deprecated";
    Pointers[Pointers["MetaData"] = 0] = "MetaData";
    Pointers[Pointers["AudioBusses"] = 1] = "AudioBusses";
    Pointers[Pointers["AudioConnection"] = 2] = "AudioConnection";
    Pointers[Pointers["AudioEffectHost"] = 3] = "AudioEffectHost";
    Pointers[Pointers["AudioFile"] = 4] = "AudioFile";
    Pointers[Pointers["AudioOutput"] = 5] = "AudioOutput";
    Pointers[Pointers["AudioPlayMode"] = 6] = "AudioPlayMode";
    Pointers[Pointers["AudioUnit"] = 7] = "AudioUnit";
    Pointers[Pointers["AudioUnits"] = 8] = "AudioUnits";
    Pointers[Pointers["Automation"] = 9] = "Automation";
    Pointers[Pointers["AuxSend"] = 10] = "AuxSend";
    Pointers[Pointers["Capture"] = 11] = "Capture";
    Pointers[Pointers["ClipCollection"] = 12] = "ClipCollection";
    Pointers[Pointers["ConnectionCollection"] = 13] = "ConnectionCollection";
    Pointers[Pointers["Device"] = 14] = "Device";
    Pointers[Pointers["DeviceUserInterface"] = 15] = "DeviceUserInterface";
    Pointers[Pointers["Editing"] = 16] = "Editing";
    Pointers[Pointers["FileUploadState"] = 17] = "FileUploadState";
    Pointers[Pointers["Groove"] = 18] = "Groove";
    Pointers[Pointers["InstrumentHost"] = 19] = "InstrumentHost";
    Pointers[Pointers["MarkerEvents"] = 20] = "MarkerEvents";
    Pointers[Pointers["MarkerTrack"] = 21] = "MarkerTrack";
    Pointers[Pointers["MIDIControl"] = 22] = "MIDIControl";
    Pointers[Pointers["MIDIControllers"] = 23] = "MIDIControllers";
    Pointers[Pointers["MIDIDevice"] = 24] = "MIDIDevice";
    Pointers[Pointers["MIDIEffectHost"] = 25] = "MIDIEffectHost";
    Pointers[Pointers["ModularSetup"] = 26] = "ModularSetup";
    Pointers[Pointers["Modulation"] = 27] = "Modulation";
    Pointers[Pointers["ModuleCollection"] = 28] = "ModuleCollection";
    Pointers[Pointers["NoteEventCollection"] = 29] = "NoteEventCollection";
    Pointers[Pointers["NoteEventFeature"] = 30] = "NoteEventFeature";
    Pointers[Pointers["NoteEvents"] = 31] = "NoteEvents";
    Pointers[Pointers["NotesConnection"] = 32] = "NotesConnection";
    Pointers[Pointers["Parameter"] = 33] = "Parameter";
    Pointers[Pointers["ParameterController"] = 34] = "ParameterController";
    Pointers[Pointers["PianoMode"] = 35] = "PianoMode";
    Pointers[Pointers["ProjectMeta"] = 36] = "ProjectMeta";
    Pointers[Pointers["RegionCollection"] = 37] = "RegionCollection";
    Pointers[Pointers["Sample"] = 38] = "Sample";
    Pointers[Pointers["Selection"] = 39] = "Selection";
    Pointers[Pointers["Shadertoy"] = 40] = "Shadertoy";
    Pointers[Pointers["SideChain"] = 41] = "SideChain";
    Pointers[Pointers["SignatureAutomation"] = 42] = "SignatureAutomation";
    Pointers[Pointers["SoundfontFile"] = 43] = "SoundfontFile";
    Pointers[Pointers["StepAutomation"] = 44] = "StepAutomation";
    Pointers[Pointers["Timeline"] = 45] = "Timeline";
    Pointers[Pointers["TrackCollection"] = 46] = "TrackCollection";
    Pointers[Pointers["TransientMarkers"] = 47] = "TransientMarkers";
    Pointers[Pointers["User"] = 48] = "User";
    Pointers[Pointers["ValueEventCollection"] = 49] = "ValueEventCollection";
    Pointers[Pointers["ValueEvents"] = 50] = "ValueEvents";
    Pointers[Pointers["ValueInterpolation"] = 51] = "ValueInterpolation";
    Pointers[Pointers["VoltageConnection"] = 52] = "VoltageConnection";
    Pointers[Pointers["WarpMarkers"] = 53] = "WarpMarkers";
    Pointers[Pointers["NeuralAmpModel"] = 54] = "NeuralAmpModel";
})(Pointers || (Pointers = {}));
